<div class="container">
  <pdq-heading element="h6">Judge.me API Token</pdq-heading>
  <div class="general">
    <pdq-input
      [value]="judgeMeApiToken"
      placeholder="Not configured"
      [readonly]="true"
      type="password"
      [clipboard]="!!judgeMeApiToken"></pdq-input>
    @if (judgeMeApiToken) {
      <p class="hint body-12-regular">To change your API Token, disconnect and reconnect.</p>
    } @else {
      <p class="hint body-12-regular">Click Connect at the top of the page to enter your Judge.me private API Token.</p>
    }
  </div>
</div>
